/**
 * Finance View deeper destinations.
 * Prefer Reporting hub (analytics entitlement) so finance can self-serve
 * without the AR Posting or Remittance ops modules.
 */

export function buildFinanceDeepDive(canAccessNavItem = () => false) {
  const reporting = Boolean(canAccessNavItem('reporting'));
  const arPosting = Boolean(canAccessNavItem('ar-posting'));
  const remittance = Boolean(canAccessNavItem('eob'));
  const analytics = Boolean(canAccessNavItem('analytics'));
  const denials = Boolean(canAccessNavItem('denials'));

  const arReportsPath = reporting
    ? '/reporting?service=arPosting'
    : arPosting
      ? '/ar-posting'
      : null;
  const remitReportsPath = reporting
    ? '/reporting?service=remittanceAdvice'
    : remittance
      ? '/eob'
      : null;
  const analyticsPath = analytics ? '/analytics' : null;
  const denialsPath = denials ? '/denials' : analyticsPath;

  const links = [
    arReportsPath && {
      id: 'ar-posting-reports',
      title: 'AR Posting reports',
      description: 'Cash posting, deposit reconciliation, auto-post, adjustments, and underpayments.',
      cta: 'Open AR posting reports',
      path: arReportsPath,
    },
    remitReportsPath && {
      id: 'remittance-reports',
      title: 'Remittance reports',
      description: 'ERA/EOB inventory, payment status, and payer remittance trends.',
      cta: 'Open remittance reports',
      path: remitReportsPath,
    },
    analyticsPath && {
      id: 'analytics',
      title: 'Analytics',
      description: 'Payer mix, posting trends, and capture confidence over time.',
      cta: 'Open analytics',
      path: analyticsPath,
    },
  ].filter(Boolean);

  return {
    links,
    kpiPath: {
      net_collection_rate: arReportsPath,
      days_in_ar: arReportsPath,
      denial_rate: denialsPath,
      remit_coverage: remitReportsPath,
      observed_capture: analyticsPath,
      ehr_coverage: analyticsPath,
    },
  };
}
